(() => {
  'use strict';
  if (window.__veloraReferenceShell) return;
  window.__veloraReferenceShell = true;
  function formatShopifyMoney(cents, format, formatCurrency, currency) {
    if (!Number.isSafeInteger(cents) || !format || !formatCurrency || !currency || formatCurrency !== currency) return null;
    const tokens = {
      amount: [2, ',', '.'], amount_no_decimals: [0, ',', '.'],
      amount_with_comma_separator: [2, '.', ','], amount_no_decimals_with_comma_separator: [0, '.', ','],
      amount_with_apostrophe_separator: [2, "'", '.'], amount_no_decimals_with_space_separator: [0, ' ', '.'],
      amount_with_space_separator: [2, ' ', ','], amount_with_period_and_space_separator: [2, ' ', '.'],
    };
    const entities = { amp: '&', lt: '<', gt: '>', quot: '"', apos: "'", nbsp: '\u00a0', thinsp: '\u2009', euro: '€', pound: '£', yen: '¥' };
    const text = String(format).replace(/&(#x[0-9a-f]+|#\d+|amp|lt|gt|quot|apos|nbsp|thinsp|euro|pound|yen);/gi, (entity, name) => {
      if (name[0] !== '#') return entities[name.toLowerCase()];
      const code = name[1].toLowerCase() === 'x' ? parseInt(name.slice(2), 16) : Number(name.slice(1));
      return code > 0 && code <= 0x10ffff ? String.fromCodePoint(code) : entity;
    }).replace(/<[^>]*>/g, '');
    const placeholders = [...text.matchAll(/{{\s*(\w+)\s*}}/g)];
    if (placeholders.length !== 1 || !Object.prototype.hasOwnProperty.call(tokens, placeholders[0][1])) return null;
    const [precision, group, decimal] = tokens[placeholders[0][1]];
    const value = BigInt(cents), absolute = value < 0n ? -value : value;
    const whole = precision ? absolute / 100n : (absolute + 50n) / 100n;
    const amount = (value < 0n ? '-' : '') + String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, group)
      + (precision ? decimal + String(absolute % 100n).padStart(2, '0') : '');
    const rendered = text.replace(placeholders[0][0], amount);
    return /{{|}}/.test(rendered) ? null : rendered;
  }
  const focusable = 'summary,a[href],button:not([disabled]),input:not([disabled]),textarea:not([disabled]),select:not([disabled]),[tabindex]:not([tabindex="-1"])';
  const create = (tag, className, text) => { const node = document.createElement(tag); if (className) node.className = className; if (text !== undefined) node.textContent = text; return node; };
  class VeloraNavigation {
    constructor(element) {
      this.element = element;
      this.shell = element.querySelector('[data-vr-shell]');
      this.backdrop = element.querySelector('[data-vr-close]');
      this.panels = [...element.querySelectorAll('[data-vr-panel]')];
      this.root = element.dataset.root || '/';
      if (!this.root.endsWith('/')) this.root += '/';
      this.currency = element.dataset.currency || 'USD';
      this.moneyFormat = element.dataset.moneyFormat || '';
      this.moneyFormatCurrency = element.dataset.moneyFormatCurrency || '';
      try { this.cartAssets = JSON.parse(element.querySelector('[data-vr-cart-assets]')?.textContent || '{}'); } catch { this.cartAssets = {}; }
      this.closeTimers = new Map();
      this.backdropTimer = 0;
      this.focusFrame = 0;
      this.modalOpen = false;
      this.pendingPanel = null;
      this.switchTimer = 0;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.cart = {items: [], item_count: 0, total_price: 0};
      this.lastFocus = null;
      this.previousOverflow = null;
      this.inertState = [];
      this.pending = false;
      this.revision = 0;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      element.querySelectorAll('[data-vr-toggle]').forEach(button => button.addEventListener('click', event => {
        event.preventDefault();
        const mode = button.dataset.vrToggle;
        if (this.mode === mode || this.pendingPanel?.mode === mode) this.close(); else this.open(mode);
      }, {signal}));
      this.backdrop.addEventListener('click', event => {
        // Only the backdrop can hand off to a visible configuration toggle.
        // The rest of main remains inert while the navigation is modal.
        const configuration = [...document.querySelectorAll('velora-reference-product .vrp-config-toggle > [data-expand]')].find(button => {
          if (button.disabled || !button.getClientRects().length) return false;
          const bounds = button.getBoundingClientRect();
          return getComputedStyle(button).visibility !== 'hidden'
            && event.clientX >= bounds.left && event.clientX <= bounds.right
            && event.clientY >= bounds.top && event.clientY <= bounds.bottom;
        });
        if (event.target === this.backdrop && configuration) {
          this.close({returnFocus: false});
          configuration.click();
          configuration.focus({preventScroll: true});
        } else this.close();
      }, {signal});
      window.addEventListener('velora:panel-opening', event => {
        if (event.detail?.panel === 'configuration' && event.detail.source !== this.element) {
          this.close({returnFocus: false});
        }
      }, {signal});
      document.addEventListener('keydown', event => this.keydown(event), {signal});
      element.addEventListener('click', event => {
        const change = event.target.closest('[data-vr-line-action]');
        if (change) { event.preventDefault(); this.change(change); }
      }, {signal});
      document.addEventListener('velora:cart-updated', event => {
        const detail = event.detail || {};
        if (detail.source === 'velora-navigation') return;
        if (detail.cart && Array.isArray(detail.cart.items)) { this.revision++; this.render(detail.cart); } else this.refresh();
        if (detail.open) this.open('cart', false);
      }, {signal});
      document.addEventListener('click', event => {
        const button = event.target.closest('[data-vr-discount-apply],[data-vr-discount-remove]');
        if (button) { event.preventDefault(); this.applyDiscount(button.closest('[data-vr-discount]'), button.dataset.vrDiscountRemove); }
      }, {signal});
      document.addEventListener('keydown', event => {
        if (event.key === 'Enter' && event.target.matches('[data-vr-discount-input]')) { event.preventDefault(); this.applyDiscount(event.target.closest('[data-vr-discount]')); }
      }, {signal});
      document.addEventListener('input', event => {
        if (event.target.matches('[data-vr-discount-input]')) { event.target.removeAttribute('aria-invalid'); event.target.closest('[data-vr-discount]').querySelector('[data-vr-discount-status]').textContent = ''; }
      }, {signal});
      window.addEventListener('pageshow', event => { if (event.persisted) this.refresh(); }, {signal});
      try { this.render(JSON.parse(element.querySelector('[data-vr-initial-cart]').textContent)); } catch { this.refresh(); }
    }
    text(key, fallback, values = {}) {
      const text = window.VeloraI18n?.t(key, fallback, values) ?? fallback;
      return String(text).replace(/\[\[([a-zA-Z_][a-zA-Z0-9_]*)\]\]/g, (token, name) => Object.prototype.hasOwnProperty.call(values, name) ? String(values[name]) : token);
    }
    money(cents) {
      const currency = this.cart.currency || this.currency;
      const value = Number(cents);
      if (!Number.isSafeInteger(value)) return '—';
      const configured = formatShopifyMoney(value, this.moneyFormat, this.moneyFormatCurrency, currency);
      if (configured !== null) return configured;
      try { return new Intl.NumberFormat(document.documentElement.lang || undefined, {style:'currency', currency}).format((Number(cents) || 0) / 100); }
      catch { return `${currency} ${((Number(cents) || 0) / 100).toFixed(2)}`; }
    }
    propertyText(key, value) {
      if (key !== 'Finish') return `${key}: ${value}`;
      const finish = String(value).trim().toLowerCase();
      const label = this.text('velora.common.finish', 'Finish');
      const display = /^(silver|gray|grey) matte$/.test(finish) ? this.text('velora.common.silver', 'Silver Matte')
        : finish === 'black matte' ? this.text('velora.common.black', 'Black Matte') : value;
      return `${label}: ${display}`;
    }
    cartPresentation(item) {
      const fallback = {url:item.url || `${this.root}cart`,imageUrl:item.featured_image?.url || (typeof item.image === 'string' ? item.image : item.image?.src || item.image?.url)};
      let productURL;
      try { productURL = new URL(fallback.url,location.origin); } catch { return fallback; }
      const handle = item.product?.handle || item.handle || productURL.pathname.match(/\/products\/([^/?#]+)/)?.[1];
      if (!this.cartAssets.handle || handle !== this.cartAssets.handle) return fallback;
      const property = String(item.properties?.Finish || '').toLowerCase();
      const title = String(item.variant_title || item.variant?.title || '').toLowerCase();
      const finish = property.includes('black') ? 'black' : /silver|gray|grey/.test(property) ? 'gray' : title.includes('black') ? 'black' : 'gray';
      const shot = title.includes('pair') ? 'pair' : 'studio';
      const weightValue = item.options_with_values?.find(option => /weight/i.test(option.name))?.value || title.match(/\b(5|10|15|20)\s*kg\b/i)?.[1];
      const weight = [5,10,15,20].find(value => value === Number.parseFloat(weightValue)) || 20;
      productURL.searchParams.set('finish',finish);
      const variantId = item.variant_id || item.variant?.id || item.id;
      if (variantId) productURL.searchParams.set('variant',variantId);
      return {url:productURL.origin===location.origin?`${productURL.pathname}${productURL.search}${productURL.hash}`:productURL.href,imageUrl:this.cartAssets.weights?.[weight]?.[finish]?.[shot] || this.cartAssets[finish]?.[shot] || fallback.imageUrl};
    }
    async refresh() {
      const revision = this.revision;
      try {
        const response = await fetch(`${this.root}cart.js`, {credentials:'same-origin',headers:{Accept:'application/json'},cache:'no-store',signal:this.abort.signal});
        if (!response.ok) throw new Error(this.text('velora.cart.load_failure', 'Your bag could not be loaded. Please try again or open the bag page.'));
        const cart = await response.json(); if (revision === this.revision && !this.pending) this.render(cart); return cart;
      } catch (error) { if (error.name !== 'AbortError') this.message(error.message); return null; }
    }
    message(text) { this.element.querySelector('[data-vr-cart-message]').textContent = text || ''; }
    render(cart) {
      if (!cart || !Array.isArray(cart.items)) return;
      this.message('');
      this.cart = cart;
      this.element.querySelectorAll('[data-vr-cart-count]').forEach(node => node.textContent = cart.item_count || 0);
      this.element.querySelector('[data-vr-cart-total]').textContent = this.money(cart.total_price);
      this.element.querySelector('[data-vr-checkout]').disabled = !cart.item_count || this.pending;
      this.renderDiscounts();
      const list = this.element.querySelector('[data-vr-cart-items]');
      list.replaceChildren();
      if (!cart.items.length) { list.append(create('p','vr-cart-empty',this.text('velora.cart.empty', 'Your bag is empty.'))); return; }
      cart.items.forEach(item => {
        const line = create('article','vr-mini-line'); line.dataset.key = item.key;
        const presentation = this.cartPresentation(item);
        const imageLink = create('a'); imageLink.href = presentation.url; imageLink.tabIndex = -1; imageLink.setAttribute('aria-hidden','true');
        const imageUrl = presentation.imageUrl;
        if (imageUrl) { const img = create('img','vr-mini-image'); img.src = imageUrl; img.alt = ''; img.width = 80; img.height = 96; imageLink.append(img); }
        const info = create('div','vr-mini-info');
        const name = create('a','',item.product_title || item.title); name.href = presentation.url; info.append(name);
        if (item.variant_title && item.variant_title !== 'Default Title') info.append(create('p','vr-mini-variant',item.variant_title));
        if (item.selling_plan_allocation?.selling_plan?.name) info.append(create('p','vr-mini-variant',item.selling_plan_allocation.selling_plan.name));
        if (item.properties) Object.entries(item.properties).forEach(([key,value]) => { if (!key.startsWith('_') && value) info.append(create('p','vr-mini-properties',this.propertyText(key,value))); });
        info.append(create('p','vr-mini-price',this.money(item.final_line_price ?? item.line_price)));
        (item.line_level_discount_allocations || []).forEach(discount => info.append(create('p','vr-mini-discount',discount.discount_application.title)));
        const actions = create('div','vr-mini-actions');
        const action = (kind,label,text) => { const button=create('button',kind==='remove'?'vr-mini-remove':'',text); button.type='button'; button.dataset.vrLineAction=kind; button.dataset.key=item.key; button.setAttribute('aria-label',label); return button; };
        actions.append(action('remove',this.text('velora.cart.remove_item','Remove [[product]]',{product:item.product_title || item.title}),'×'));
        const quantity=create('div','vr-quantity'); quantity.append(action('minus',this.text('velora.cart.decrease_item','Decrease quantity of [[product]]',{product:item.product_title || item.title}),'−'));
        const count=create('span','',item.quantity); count.setAttribute('aria-label',this.text('velora.cart.quantity_count','Quantity: [[count]]',{count:item.quantity})); quantity.append(count,action('plus',this.text('velora.cart.increase_item','Increase quantity of [[product]]',{product:item.product_title || item.title}),'+')); actions.append(quantity);
        line.append(imageLink,info,actions); list.append(line);
      });
    }
    async change(button) {
      if (this.pending) return;
      const key=button.dataset.key, action=button.dataset.vrLineAction;
      const item=this.cart.items.find(line => line.key === key); if (!item) return;
      const increment=Number(item.quantity_rule?.increment) || 1;
      const minimum=Number(item.quantity_rule?.min) || 1;
      let target=action === 'remove' ? 0 : Math.max(0,item.quantity+(action === 'plus'?increment:-increment));
      if(target < minimum) target=0;
      this.revision++;
      this.pending=true; this.lockDiscountControls(); this.message(this.text('velora.cart.updating', 'Updating your bag…'));
      this.element.querySelector('[data-vr-panel="cart"]').setAttribute('aria-busy','true');
      this.element.querySelectorAll('[data-vr-line-action],[data-vr-checkout]').forEach(node => node.disabled=true);
      try {
        const response=await fetch(`${this.root}cart/change.js`,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity:target}),signal:this.abort.signal});
        const data=await response.json();
        if (!response.ok || !Array.isArray(data.items)) throw new Error(typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : this.text('velora.cart.quantity_unavailable', 'This quantity is not available. Please choose another quantity.'));
        this.render(data); this.message(target ? this.text('velora.cart.updated', 'Your bag has been updated.') : this.text('velora.cart.removed', 'Item removed from your bag.'));
        const next=[...this.element.querySelectorAll('[data-vr-line-action]')].find(node => node.dataset.key===key && node.dataset.vrLineAction===action);
        (next || this.element.querySelector('[data-vr-toggle="cart"]')).focus({preventScroll:true});
        this.publishCart(data);
      } catch(error) { if(error.name!=='AbortError') { this.message(error.message); button.focus({preventScroll:true}); } }
      finally {
        this.pending=false; if(this.abort.signal.aborted) return; this.lockDiscountControls(); this.element.querySelector('[data-vr-panel="cart"]').removeAttribute('aria-busy');
        this.element.querySelectorAll('[data-vr-line-action]').forEach(node => node.disabled=false);
        this.element.querySelector('[data-vr-checkout]').disabled=!this.cart.item_count;
        if(button.isConnected && document.activeElement===document.body)button.focus({preventScroll:true});
      }
    }
    publishCart(cart) {
      document.dispatchEvent(new CustomEvent('velora:cart-updated', { detail: { cart, open: false, source: 'velora-navigation' } }));
      document.dispatchEvent(new CustomEvent('velora:cart-changed', { detail: { cart } }));
    }
    lockDiscountControls() {
      document.querySelectorAll('[data-vr-discount-apply],[data-vr-discount-remove],[data-vr-discount-input],[data-vr-native-cart-submit]').forEach(node => node.disabled = this.pending || !this.cart.item_count);
    }
    renderDiscounts() {
      if (!window.VeloraDiscounts) return;
      const codes = window.VeloraDiscounts.codes(this.cart);
      document.querySelectorAll('[data-vr-discount]').forEach(widget => {
        widget.hidden = !this.cart.item_count;
        widget.querySelector('[data-vr-discount-status]').textContent = '';
        const list = widget.querySelector('[data-vr-discount-codes]'); list.replaceChildren();
        codes.forEach(code => {
          const line = create('li','vr-discount-code'), label = create('span','',code), remove = create('button','','×');
          remove.type = 'button'; remove.dataset.vrDiscountRemove = code; remove.setAttribute('aria-label',this.text('velora.discount.remove','Remove discount [[code]]',{code}));
          line.append(label,remove); list.append(line);
        });
      });
      const totals = this.element.querySelector('[data-vr-cart-discounts]');
      if (totals) {
        totals.replaceChildren();
        (this.cart.cart_level_discount_applications || []).forEach(discount => {
          const line = create('p'); line.append(create('span','',discount.title),create('span','',`−${this.money(discount.total_allocated_amount)}`)); totals.append(line);
        });
      }
      this.lockDiscountControls();
    }
    async applyDiscount(widget, removeCode) {
      if (!widget || this.pending || !this.cart.item_count || !window.VeloraDiscounts) return;
      const input = widget.querySelector('[data-vr-discount-input]'), status = widget.querySelector('[data-vr-discount-status]');
      const code = removeCode ?? input.value.trim();
      if (!code) { status.textContent = this.text('velora.discount.enter', 'Enter a discount code.'); input.setAttribute('aria-invalid','true'); input.focus(); return; }
      this.pending = true; this.revision++; this.lockDiscountControls();
      widget.setAttribute('aria-busy','true'); status.textContent = removeCode ? this.text('velora.discount.removing', 'Removing discount…') : this.text('velora.discount.applying', 'Applying discount…');
      this.element.querySelector('[data-vr-checkout]').disabled = true;
      let confirmed = false;
      try {
        const result = await window.VeloraDiscounts.update({ root: this.root, code, remove: removeCode !== undefined, signal: this.abort.signal, translate: (key, fallback) => this.text(key, fallback) });
        this.render(result.cart); this.publishCart(result.cart);
        confirmed = result.confirmed;
        status.textContent = result.message;
        if (confirmed) { input.value = ''; input.removeAttribute('aria-invalid'); }
        else input.setAttribute('aria-invalid','true');
      } catch (error) { if (error.name !== 'AbortError') status.textContent = error.message || this.text('velora.discount.update_failure', 'The discount could not be updated. Please try again.'); }
      finally {
        this.pending = false; if (this.abort.signal.aborted) return; this.lockDiscountControls(); widget.removeAttribute('aria-busy');
        this.element.querySelector('[data-vr-checkout]').disabled = !this.cart.item_count;
        if (widget.isConnected && widget.open) input.focus({preventScroll:true});
      }
      // Full-cart lines remain Shopify-rendered, including any discount splits.
      if (confirmed && widget.dataset.cartPage === 'true') location.reload();
    }
    cancelPendingPanel() {
      clearTimeout(this.switchTimer); this.switchTimer=0; this.pendingPanel=null;
    }
    open(mode='cart',refresh=true) {
      if (!['menu','cart'].includes(mode)) return;
      if(this.pendingPanel?.mode===mode) return;
      this.cancelPendingPanel();
      if(this.mode && this.mode!==mode && !this.reducedMotion.matches) {
        const previous=this.panels.find(panel=>panel.dataset.vrPanel===this.mode);
        // Finish the current disclosure before expanding a different one.
        // Keep the backdrop/modal lock so background controls cannot steal it.
        this.close({returnFocus:false,keepModal:true});
        const pending={mode,refresh}; this.pendingPanel=pending;
        this.switchTimer=setTimeout(()=>{
          if(this.pendingPanel!==pending) return;
          this.pendingPanel=null; this.switchTimer=0;
          this.open(pending.mode,pending.refresh);
        },previous ? this.closeDelay(previous,true) : 0);
        return;
      }
      // Product configuration relinquishes its panel before main is made inert.
      window.dispatchEvent(new CustomEvent('velora:panel-opening', {detail:{panel:mode,source:this.element}}));
      clearTimeout(this.backdropTimer);
      cancelAnimationFrame(this.focusFrame);
      const firstOpen=!this.modalOpen;
      if(firstOpen) {
        this.modalOpen=true;
        this.lastFocus=document.activeElement;
        this.previousOverflow=document.body.style.overflow; document.body.style.overflow='hidden';
        this.inertState=[...document.querySelectorAll('main,[data-vr-footer]')].filter(node=>!node.contains(this.element)).map(node=>[node,node.inert]);
        this.inertState.forEach(([node])=>node.inert=true);
      }
      this.mode=mode;
      this.backdrop.hidden=false;
      this.panels.forEach(panel=>{
        clearTimeout(this.closeTimers.get(panel));
        this.closeTimers.delete(panel);
        const active=panel.dataset.vrPanel===mode;
        panel.hidden=!active; panel.inert=!active;
        if(!active) delete panel.dataset.active;
      });
      // Commit the collapsed state when opening from display:none. Reopening
      // during a close keeps the current interpolated height and reverses it.
      if(!this.reducedMotion.matches) this.shell.getBoundingClientRect();
      this.shell.dataset.open=mode; this.element.dataset.open=mode;
      this.shell.setAttribute('role','dialog'); this.shell.setAttribute('aria-modal','true'); this.shell.setAttribute('aria-label',mode==='cart'?this.text('velora.cart.title', 'Your bag'):this.text('velora.navigation.main', 'Main navigation'));
      this.panels.forEach(panel=>{ if(panel.dataset.vrPanel===mode) panel.dataset.active=''; });
      this.element.querySelectorAll('[data-vr-toggle]').forEach(node=>node.setAttribute('aria-expanded',String(node.dataset.vrToggle===mode)));
      if(mode==='cart'&&refresh) this.refresh();
      this.focusFrame=requestAnimationFrame(()=>{
        this.focusFrame=0;
        if(this.mode===mode) this.element.querySelector(`[data-vr-toggle="${mode}"]`)?.focus({preventScroll:true});
      });
    }
    closeDelay(element, includeRows=false) {
      if(this.reducedMotion.matches) return 0;
      const elements=[element];
      if(includeRows) elements.push(...element.querySelectorAll('.vr-menu-grid > *, .vr-menu-legal, .vr-mini-cart > *'));
      const milliseconds=value=>parseFloat(value)*(value.trim().endsWith('ms') ? 1 : 1000) || 0;
      const duration=Math.max(0,...elements.map(node=>{
        const style=getComputedStyle(node);
        if(style.transitionProperty==='none') return 0;
        const durations=style.transitionDuration.split(',').map(milliseconds);
        const delays=style.transitionDelay.split(',').map(milliseconds);
        return Math.max(0,...durations.map((value,index)=>value+delays[index%delays.length]));
      }));
      // Let the final transition frame paint before applying display:none.
      return duration>0 ? Math.ceil(duration)+34 : 0;
    }
    close(options=true) {
      const returnFocus=typeof options==='boolean' ? options : options?.returnFocus!==false;
      const keepModal=typeof options==='object' && options?.keepModal===true;
      this.cancelPendingPanel();
      cancelAnimationFrame(this.focusFrame); this.focusFrame=0;
      if(!this.mode && !this.modalOpen) return;
      this.mode=null; delete this.shell.dataset.open;
      if(!keepModal) {
        delete this.element.dataset.open;
        this.shell.removeAttribute('role'); this.shell.removeAttribute('aria-modal'); this.shell.removeAttribute('aria-label');
      }
      this.panels.forEach(panel=>{
        clearTimeout(this.closeTimers.get(panel)); this.closeTimers.delete(panel);
        delete panel.dataset.active; panel.inert=true;
        const duration=panel.hidden ? 0 : this.closeDelay(panel,true);
        if(!duration) panel.hidden=true;
        else this.closeTimers.set(panel,setTimeout(()=>{
          this.closeTimers.delete(panel);
          if(!panel.hasAttribute('data-active')) panel.hidden=true;
        },duration));
      });
      this.element.querySelectorAll('[data-vr-toggle]').forEach(node=>node.setAttribute('aria-expanded','false'));
      clearTimeout(this.backdropTimer);
      if(!keepModal) {
        const backdropDuration=this.closeDelay(this.backdrop);
        if(!backdropDuration) this.backdrop.hidden=true;
        else this.backdropTimer=setTimeout(()=>{this.backdropTimer=0;if(!this.modalOpen)this.backdrop.hidden=true;},backdropDuration);
        // Restore these synchronously: a configuration handoff focuses into main.
        document.body.style.overflow=this.previousOverflow || ''; this.previousOverflow=null;
        this.inertState.forEach(([node,state])=>node.inert=state); this.inertState=[];
        this.modalOpen=false;
        if(returnFocus && this.lastFocus?.isConnected) this.lastFocus.focus({preventScroll:true});
        this.lastFocus=null;
      }
    }
    keydown(event) {
      if(!this.modalOpen) return;
      if(event.key==='Escape') { event.preventDefault(); this.close(); return; }
      if(event.key!=='Tab') return;
      // Safari's system keyboard preference can skip links during native Tab.
      // Advance explicitly through the same visible modal controls on every Tab.
      event.preventDefault();
      const nodes=[...this.shell.querySelectorAll(focusable)].filter(node=>node.tabIndex>=0 && !node.matches(':disabled') && !node.closest('[inert]') && node.getClientRects().length && getComputedStyle(node).visibility!=='hidden');
      if(!nodes.length) return;
      const current=nodes.indexOf(document.activeElement);
      const next=current<0 ? (event.shiftKey ? nodes.length-1 : 0) : (current+(event.shiftKey ? -1 : 1)+nodes.length)%nodes.length;
      nodes[next].focus();
    }
    destroy() {
      this.close(false); this.abort.abort();
      cancelAnimationFrame(this.focusFrame); clearTimeout(this.backdropTimer);
      this.closeTimers.forEach(timer=>clearTimeout(timer)); this.closeTimers.clear();
      this.panels.forEach(panel=>panel.hidden=true); this.backdrop.hidden=true;
    }
  }
  let instance;
  const init=()=>{
    const node=document.querySelector('[data-vr-navigation]');
    if(!node) return;
    if(instance?.element===node) { instance.renderDiscounts(); return; }
    instance?.destroy(); instance=new VeloraNavigation(node);
    window.VeloraCart={open:()=>instance.open('cart'),close:()=>instance.close(),refresh:()=>instance.refresh()};
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
  document.addEventListener('shopify:section:load',init);
})();
